<h1 mat-dialog-title>{{'TOBA LIGHT.label.Category' | translate}}</h1>
<form [formGroup]="form" (ngSubmit)="onSubmit()" autocomplete="off">
    <div mat-dialog-content>
        <div fxLayout="row wrap">
            <div fxFlex="100">
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>{{'TOBA LIGHT.banner.title' | translate}}</mat-label>
                    <input matInput formControlName="title" required>
                    <mat-error *ngIf="form.controls.title.errors?.required">{{'TOBA LIGHT.banner.title' | translate}} is required</mat-error>
                </mat-form-field>
            </div>
            <div fxFlex="100">
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>{{'TOBA LIGHT.banner.subTitle' | translate}}</mat-label>
                    <input matInput formControlName="subtitle">

                </mat-form-field>
            </div>
            <div fxFlex="100">
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>{{'TOBA LIGHT.banner.link' | translate}}</mat-label>
                    <input matInput formControlName="link" required>
                    <mat-error *ngIf="form.controls.link.errors?.required">{{'TOBA LIGHT.banner.link' | translate}} is required</mat-error>
                </mat-form-field>
            </div>
            <div fxFlex="40" class="px-2">
                <p class="mt-1"><span class="uppercase fw-500">{{'TOBA LIGHT.banner.image' | translate}}</span><span class="text-muted px-1">{{'TOBA LIGHT.banner.maxImages' | translate}}</span></p>
                <input-file formControlName="image" fileLimit="1" fileAccept="image/*"></input-file>
            </div>
        </div>
    </div>
    <div mat-dialog-actions>
        <div fxLayout="row" fxLayoutAlign="space-between center" class="w-100">
            <button mat-raised-button color="warn" type="button" mat-dialog-close>{{'TOBA LIGHT.label.close' | translate}}</button>
            <button mat-raised-button color="primary" type="submit">{{'TOBA LIGHT.label.save' | translate}}</button>
        </div>
    </div>
</form>
